type color = 'green' | 'black' | 'orange' | 'darkGreen';

export type Highlights = Record<string, color | undefined>;

type TextWithHighlightProps = { text: string; highlights: Highlights };

export const TextWithHighlight = ({ text, highlights }: TextWithHighlightProps) => {
  const entries = Object.entries(highlights);

  let stringWithDividers = text;

  entries.forEach(([string]) => {
    stringWithDividers = stringWithDividers.replace(new RegExp(string, 'g'), string ? `|||${string}|||` : '');
  });

  const splitString = stringWithDividers.split('|||');

  return splitString.map(string => (
    <span style={{ color: getColor(highlights[string]) }} key={string}>
      {string}
    </span>
  ));
};

const getColor = (color?: color) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (color) {
    case 'black':
      return 'black';
    case 'green':
      return '#01918E';
    case 'orange':
      return '#FFA346';
    case 'darkGreen':
      return '#013433';
    default:
      return '';
  }
};
